import React, { useState } from "react";
import DefaultInput from "../../inputs/defaultInput";
import DefaultButton from "../../buttons/defaultButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultDatePicker from "../../inputs/defaultDatePicker";
import PageTableHeader from "../../pageTableHeader/pageTableHeader";
import DefaultSearchSelectInput from "../../inputs/defaultSearchSelectInput";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DynamicTable from "../../table/dynamicTable";
import Loading from "../../skeleton/loading";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import DragAndDropFile from "../../inputs/simpleFileUploader";

const CreatePurchaseInvoiceForm = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState();
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    invoiceNumber: Yup.string().trim().required("Invoice Number is required"),
    orderNumber: Yup.string()
      .trim()
      .required("Purchase Order Number is required"),
    dueDate: Yup.string().trim().required("Delivery Date is required"),
    vendor: Yup.string().trim().required("vendor is required"),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      invoiceNumber: data?.invoiceNumber || "",
      orderNumber: data?.orderNumber || "",
      dueDate: data?.dueDate || "",
      vendor: data?.vendor || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  const purchaseOrderColumns = [
    { key: "Item", type: "text" },
    { key: "Quantity", type: "number" },
    { key: "Supplier", type: "text" },
    { key: "Category", type: "dropdown" },
  ];

  const categories = ["Office Supplies", "IT Equipment", "Furniture"];

  const [loading, setLoading] = useState(false);

  const urgencyData = [
    { id: "1", label: "High", value: "high" },
    { id: "2", label: "Low", value: "low" },
  ];

  return (
    <div className={"flex flex-col gap-2"}>
      {loading ? (
        <Loading />
      ) : (
        <div className={"bg-white flex flex-col gap-2"}>
          <form className="flex flex-col gap-2">
            <div className={"flex flex-col"}>
              <div className="flex items-center h-10 px-4">
                <h3 className="text-sm font-bold text-theme">
                  Create Purchase Invoice
                </h3>
              </div>
              <div className={"grid grid-cols-1 md:grid-cols-4 gap-2 p-4"}>
                <DefaultInput
                  label={"Invoice No."}
                  placeholder={"ST-001"}
                  name="invoiceNumber"
                  value={values.invoiceNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.invoiceNumber && errors.invoiceNumber
                      ? errors.invoiceNumber
                      : ""
                  }
                  required
                />
                <DefaultInput
                  label={"Purchase Order No."}
                  placeholder={"ST-001"}
                  name="orderNumber"
                  value={values.orderNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.orderNumber && errors.orderNumber
                      ? errors.orderNumber
                      : ""
                  }
                  required
                />
                <DefaultSearchSelectInput
                  label={"Select Vendor"}
                  classnames="border-white hover:border-borderColor"
                  name="category"
                  placeholder={""}
                  value={values.vendor}
                  error={touched.vendor && errors.vendor ? errors.vendor : ""}
                  required
                  options={urgencyData}
                />

                <DefaultDatePicker
                  label={"Due Date"}
                  placeholder={"Select"}
                  name="dueDate"
                  onChange={""}
                  type="date"
                  required
                  error={
                    touched.dueDate && errors.dueDate ? errors.dueDate : ""
                  }
                />
              </div>

              {/* Dynamic Table */}
              <DynamicTable
                initialColumns={purchaseOrderColumns}
                categories={categories}
              />

              {/* textarea */}
              <div className="p-4">
                <DefaultTextarea
                  classnames="rounded-md border-0 bg-light"
                  name={"address"}
                  label={"Notes (Optional)"}
                  placeholder={"Write  here..."}
                  boxheight={15}
                />
              </div>
              <div className="p-4 grid grid-cols-2">
                <DragAndDropFile label={"Upload Attachment"}/>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex flex-row gap-2 p-4">
              <DefaultButton variant="default" name={"Create"} type="submit" />
              <DefaultButton variant="primary" name={"Cancel"} type="submit" />
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CreatePurchaseInvoiceForm;
